import { render } from "./PinGroup.vue?vue&type=template&id=09440511&scoped=true"
import script from "./PinGroup.vue?vue&type=script&lang=js"
export * from "./PinGroup.vue?vue&type=script&lang=js"

import "./PinGroup.vue?vue&type=style&index=0&id=09440511&lang=scss&scoped=true"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09440511"]])

export default __exports__